import React, { useEffect, useState } from "react";
import {
  API_TOKEN_NAME,
  USER_ID,
  USER_ROLE,
  USER_EMAIL,
  LOGIN_PHONE_NUMBER,
  PATIENT_NAME,
  SEARCH_SELECTED_DOC_ID,
  SEARCH_SELECTED_DOC_NAME,
  SCHEDULE_DATE,
  IMAGE_URL,
} from "../../constants";
import { scAxios, scAxiosAdmin, scAxiosSMS } from "../..";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { startUserSession } from "../../userSession";
import uhlcare_logo from "../../images/uhlcare-logo.webp";
import uhl_logo from "../../images/UHL (2).webp";
import medix_logo from "../../images/medix-logo.webp";
import ma_rashed_logo from "../../images/ma rashed hospital.webp";
import mainlogo from "../../images/main-logo.webp";

const SendUsInquiry = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [formData, setFormData] = useState({
    type: "inquiry",
    first_name: "",
    phone_number: "",
    email: "",
    message: "",
  });
  const input_field_css = {
    maxHeight: "50px",
    fontSize: "14px",
    borderColor: "#cccccc",
    borderRadius: "5px",
  };
  const alertStyle = {
    color: "red",
  };
  const inputStyles = {
    borderRadius: "10px",
    background: "#fff",
    borderRight: "solid 1px #fff",
    border: "solid 1px #6e6e6ed0",
    padding: "15px 15px",
    fontSize: "16px",
    color: "#000",
    width: "100%",
  };

  const isDisabled = () => {
    if (
      formData.first_name === "" ||
      formData.email === "" ||
      formData.phone_number === "" ||
      formData.message === ""
    ) {
      return true;
    } else return false;
  };

  const handleSubmit = (event, props) => {
    event.preventDefault();

    try {
      const req = scAxiosAdmin
        .post("/emergenecies_enquiry", formData, {
          method: "post",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
        })
        .then((data) => {
          if (data.status === 201) {
            toast.success("Inquiry sent successfully!");
            setFormData({
              first_name: "",
              phone_number: "",
              email: "",
              message: "",
            });
          }
        });
    } catch (error) {}
  };
  return (
    <div>
      <div
        class="offcanvas offcanvas-start"
        data-bs-scroll="true"
        tabindex="-1"
        id="SendUsInquiry"
        aria-labelledby="offcanvasWithBothOptionsLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel"></h5>
          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body">
          <div className="left-offcanvas">
            <h4 style={{ color: "#af9763" }}>Send us an Inquiry</h4>
            <form
              onSubmit={handleSubmit}
              id="registerform"
              className="needs-validation mt-5"
              noValidate
            >
              <div className="row">
                {/* <label>Your Name</label> */}
                <div className="input-group mb-4">
                  <input
                    style={inputStyles}
                    type="text"
                    className="custom-form-control shadow-sm"
                    placeholder="Enter Your Full Name "
                    name="fullname"
                    id="fullname"
                    value={formData.fullName}
                    onChange={(e) =>
                      setFormData({ ...formData, first_name: e.target.value })
                    }
                    required
                    autoComplete="off"
                    // style={input_field_css}
                  />
                </div>
                <span /* style={alertStyle} */>
                  {/* {this.sta
                   */}
                </span>
              </div>
              <div className="row">
                {/* <label>Your Phone Number</label> */}
                <div className="input-group mb-4">
                  <input
                    style={inputStyles}
                    type="text"
                    className="custom-form-control shadow-sm"
                    placeholder="Enter Your Phone Number Here"
                    name="phoneNumber"
                    id="phoneNumber"
                    value={formData.phone_number}
                    onChange={(e) =>
                      setFormData({ ...formData, phone_number: e.target.value })
                    }
                    required
                    autoComplete="off"
                    // style={input_field_css}
                  />
                </div>
                <span /* style={alertStyle} */>
                  {/* {this.state.errors.fullname} */}
                </span>
              </div>
              <div className="row">
                {/* <label>Your Email</label> */}
                <div className="input-group mb-4">
                  <input
                    style={inputStyles}
                    type="text"
                    className="custom-form-control shadow-sm"
                    placeholder="Enter Your Email Here"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    required
                    autoComplete="off"
                    // style={input_field_css}
                  />
                </div>
                <span /* style={alertStyle} */>
                  {/* {this.state.errors.fullname} */}
                </span>
              </div>
              <div className="row">
                {/* <label>Your Message</label> */}
                <div className="input-group mb-2">
                  <textarea
                    style={inputStyles}
                    type="text-area"
                    className="custom-form-control shadow-sm"
                    placeholder="Enter Your Message "
                    name="message"
                    id="message"
                    value={formData.message}
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                    required
                    autoComplete="off"
                    // style={input_field_css}
                  />
                </div>
                <span /* style={alertStyle} */>
                  {/* {this.state.errors.fullname} */}
                </span>
              </div>
              <div className="row mt-2">
                <div className="col-12">
                  <button
                    variant="primary"
                    type="submit"
                    className="btn-links appointment-new submit_btn"
                    id="black-btn"
                    disabled={isDisabled()}
                    style={{
                      backgroundColor: isDisabled() ? "" : "#187979",
                    }}
                  >
                    Submit Your Query{" "}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendUsInquiry;



// WEBPACK FOOTER //
// ./src/component/frontend/SendUsInquiry.js